import { GetServerSideProps } from 'next'
import Layout from 'components/layout'
import routes from 'routes'
import { NextSeo } from 'next-seo'
import TagListStatic from 'components/tag-list-static'
import Breadcrumb from 'components/breadcrumb'
import TitleBar from 'components/title-bar'
import { withStorage } from 'utils/withFunction'
import JsonLd from 'components/json-ld'
import { HOST } from 'config'
import TagsData from 'data/tags.json'

const Tags = ({ tags }: { tags: any }): JSX.Element => {
  return (
    <Layout>
      <NextSeo canonical={routes.tag.list()} />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'AnyStories',
              item: HOST,
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Story Tags',
              item: `${HOST}/tags`,
            },
          ],
        }}
      />
      <TitleBar title={'Tags'} />
      <div className="hidden lg:block px-4 py-3">
        <Breadcrumb
          className="mr-4"
          items={[
            {
              name: 'Tags',
            },
          ]}
        />
      </div>
      <div className="px-4 py-3">
        <h1 className="inline-block text-xl font-bold mr-4">
          Trending Stories and Novels Keywords
        </h1>
        <span className="text-xs text-gray-400">
          {/* {tags.total} tags in total */}
          2000 tags in total
        </span>
      </div>
      <div className="px-4 py-3">
        <TagListStatic tags={tags} />
      </div>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = withStorage(async () => {
  // const tags = await api.tag.getTags({
  //   pageIndex: 1,
  // })
  return {
    props: {
      tags: TagsData,
    },
  }
})

export default Tags
